import type { DetailedHTMLProps, FormHTMLAttributes, JSX } from 'react';

type Props = DetailedHTMLProps<
  FormHTMLAttributes<HTMLFormElement>,
  HTMLFormElement
>;

/**
 * Can be placed within `<ModalContent>` to wrap `<ModalBody>` and `<ModalFooter>` components when building forms.
 */
export const ModalForm = ({ children, ...rest }: Props): JSX.Element => (
  <form
    css={{
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      height: '100%',
      width: '100%',
    }}
    {...rest}
  >
    {children}
  </form>
);
